export const REGISTRATION_NUMBER_QUERY_KEY = 'regNo'
